import React, { useState } from "react";
import api from "../lib/api";
import PageHeader from "../components/PageHeader";
import { damga } from "../lib/stamp";
import { toast } from "sonner";
import { FileSpreadsheet, Download, Loader2, ClipboardList, Factory, Boxes, ShieldCheck, Flame, Layers } from "lucide-react";

const SHEETS = [
  { no: 1, ad: "Gelen Sipariş", aciklama: "Sipariş tarihi, termin, müşteri, ürün/kalıp kodu, renk, adet", icon: ClipboardList },
  { no: 2, ad: "Şekillenen Ürün", aciklama: "Tarih, vardiya, kalıp kodu, açıklama, makina, şekillenen/defo/net", icon: Factory },
  { no: 3, ad: "Bisküvi Girişi", aciklama: "Tarih, vardiya, kalıp kodu, 1.kalite, defolu, kırık, toplam, KG", icon: Boxes },
  { no: 4, ad: "Yapılan Ürün", aciklama: "Tarih, vardiya, bölüm, ürün kodu, renk, 1.kalite, fire, toplam, KG", icon: Layers },
  { no: 5, ad: "Bisküvi Fırın Yükleme", aciklama: "Tarih, vardiya, saat, kalıp kodu, yüklenen adet, vagon, personel", icon: Flame },
  { no: 6, ad: "Kalite Takibi", aciklama: "Tarih, vardiya, ürün kodu, 1/2/3.kalite, fire, toplam + 25 defo nedeni", icon: ShieldCheck },
  { no: 7, ad: "Bisküvi Stok", aciklama: "Ekrandaki tüm hesaplanan sütunlar (şekillenen, üretilen, stok, kalan, termin)", icon: Boxes },
  { no: 8, ad: "Yapılan Ürün Müşterisi", aciklama: "1. kalitenin termine göre siparişlere düşürüldüğü kalemler", icon: ClipboardList },
];

export default function AylikRapor() {
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");
  const [busy, setBusy] = useState(false);

  const indir = async () => {
    setBusy(true);
    try {
      const params = {};
      if (start) params.start = start;
      if (end) params.end = end;
      const res = await api.get("/reports/aylik-excel", { params, responseType: "blob" });
      const url = URL.createObjectURL(new Blob([res.data]));
      const a = document.createElement("a");
      a.href = url;
      a.download = `Aylık Rapor - ${damga()}.xlsx`;
      a.click();
      URL.revokeObjectURL(url);
      toast.success("Aylık rapor indiriliyor (6 sayfalı Excel)");
    } catch {
      toast.error("Rapor oluşturulamadı");
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <PageHeader title="Aylık Rapor" subtitle="Tüm modüllerin verisini tek Excel dosyasında, her modül ayrı sayfada (sheet) indirin" />
      <div className="p-6 space-y-6" data-testid="aylik-rapor-page">
        <div className="border border-zinc-200 bg-white rounded-sm p-4 flex items-end gap-3 flex-wrap">
          <div>
            <label className="block text-[10px] font-semibold text-zinc-500 uppercase mb-0.5">Başlangıç Tarihi</label>
            <input type="date" value={start} onChange={(e) => setStart(e.target.value)} data-testid="aylik-start"
              className="border border-zinc-300 rounded-sm px-2 py-1.5 text-sm mono" />
          </div>
          <div>
            <label className="block text-[10px] font-semibold text-zinc-500 uppercase mb-0.5">Bitiş Tarihi</label>
            <input type="date" value={end} onChange={(e) => setEnd(e.target.value)} data-testid="aylik-end"
              className="border border-zinc-300 rounded-sm px-2 py-1.5 text-sm mono" />
          </div>
          {(start || end) && (
            <button onClick={() => { setStart(""); setEnd(""); }} data-testid="aylik-clear-btn"
              className="border border-zinc-300 hover:bg-zinc-50 text-zinc-600 text-sm font-semibold px-3 py-1.5 rounded-sm">Temizle</button>
          )}
          <div className="flex-1" />
          <button onClick={indir} disabled={busy} data-testid="aylik-indir-btn"
            className="flex items-center gap-2 bg-emerald-600 hover:bg-emerald-700 disabled:opacity-60 text-white text-sm font-bold px-5 py-2.5 rounded-sm transition-colors">
            {busy ? <Loader2 className="animate-spin" size={16} /> : <Download size={16} />} Excel'e Aktar (6 Sayfa)
          </button>
        </div>

        <div className="border border-zinc-200 bg-white rounded-sm overflow-hidden">
          <div className="flex items-center gap-2 px-4 py-2.5 bg-zinc-800 text-white font-head font-bold text-sm uppercase tracking-wide">
            <FileSpreadsheet size={16} /> Excel İçeriği — Sayfalar (Sheet)
          </div>
          <div className="divide-y divide-zinc-100">
            {SHEETS.map((s) => (
              <div key={s.no} className="flex items-center gap-4 px-4 py-3" data-testid={`aylik-sheet-${s.no}`}>
                <div className="flex items-center justify-center h-9 w-9 rounded-md bg-emerald-50 text-emerald-700 font-head font-black">{s.no}</div>
                <s.icon size={18} className="text-zinc-400 shrink-0" />
                <div className="min-w-0">
                  <div className="font-semibold text-zinc-900 text-sm">{s.no}. {s.ad}</div>
                  <div className="text-xs text-zinc-500 truncate">{s.aciklama}</div>
                </div>
              </div>
            ))}
          </div>
          <div className="px-4 py-2.5 text-[11px] text-zinc-400 border-t border-zinc-100">
            Tarih aralığı seçilmezse tüm veriler aktarılır. Otomatik gelen alanlar (kalıp kodu, renk, açıklama) ekrandaki gibi doldurulur.
          </div>
        </div>
      </div>
    </>
  );
}
